let currentProduct;
let iframeSrc;
let customer = 'MODUSFURNITURE';

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazingProjectAvailable === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};

const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        // WAIT FOR INSERT ELEMENTS
        const imgGallery = await waitForElement('.product-gallery--viewer');
        const thumbGallery = await waitForElement('.gallery-navigation--scroller');
        const productSkuElement = await waitForElement('.product-sku span');

        // GENERATE IFRAME SRC BASED ON CUSTOMER, URL AND INPUT VALUES
        iframeSrc = await mazingProjectAvailable({
            customerName: customer,
            getSKU: () => {
                const url = window.location.href;
                const parts = url.split("/");
                const product = parts.filter(part => part.trim() !== '').pop();
                const productParts = product.split('?');

                //currentProduct = `${productParts[0]}`;
                currentProduct = productSkuElement.textContent.trim();

                console.log('extracted sku: ' + currentProduct.toLowerCase());

                return currentProduct.toLowerCase();
            }
        });

        // STOP SCRIPT IF NO IFRAME SRC IS FOUND
        if (!iframeSrc) {
            console.log('iframeSrc not found, skipping update.');
            return;
        }

        // MAZING IFRAME START

        const figureElement = document.createElement('figure');
        figureElement.classList.add('product-gallery--media', 'product-gallery--image');
        figureElement.id = 'mazing-figure';
        figureElement.setAttribute('data-gallery-selected', 'false');
        figureElement.setAttribute('data-gallery-figure', '')
        figureElement.setAttribute('data-media-type', 'image');
        figureElement.setAttribute('aria-hidden', 'true');
        figureElement.setAttribute('data-zoom', 'https://mazingxr.com');

        const iframeWrapper = document.createElement('div');
        iframeWrapper.classList.add('product-gallery--image-background');
        iframeWrapper.style.overflow = 'hidden';
        iframeWrapper.style.top = '0';
        iframeWrapper.style.left = '0';
        iframeWrapper.style.paddingTop = 'min(100%, 100%)';
        iframeWrapper.style.maxWidth = '100%';
        iframeWrapper.style.marginLeft = 'auto';
        iframeWrapper.style.marginRight = 'auto';
        iframeWrapper.style.height = '100%';
        iframeWrapper.style.width = '100%';
        iframeWrapper.id = 'mazing-div';

        const iframe = document.createElement('iframe');
        iframe.src = iframeSrc;
        iframe.style.border = '0';
        iframe.style.height = '100%';
        iframe.style.left = '0';
        iframe.style.position = 'absolute';
        iframe.style.maxHeight = '100%';
        iframe.style.top = '0';
        iframe.style.width = '100%';
        iframe.setAttribute('allowusermedia', '');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('data-cy', 'cy-mazing-frame');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking');

        iframeWrapper.appendChild(iframe);
        figureElement.appendChild(iframeWrapper);
        const firstChild = imgGallery.children[0];
        imgGallery.insertBefore(figureElement, firstChild.nextSibling);
        imgGallery.style.scrollBehavior = 'smooth';

        // MAZING IFRAME END

        const existingThumb = thumbGallery.querySelector('.product-gallery--media-thumbnail');

        // MAZING THUMB START
        const newThumbElement = document.createElement('button');
        newThumbElement.classList.add('product-gallery--media-thumbnail');
        newThumbElement.type = 'button';
        newThumbElement.id = 'mazing-thumb';
        newThumbElement.tabIndex = 0;
        newThumbElement.setAttribute('data-gallery-selected', 'false');
        newThumbElement.setAttribute('data-media-type', 'image');

        const thumbImgWrapper = document.createElement('span');
        thumbImgWrapper.classList.add('product-gallery--media-thumbnail-img-wrapper');
        thumbImgWrapper.tabIndex = -1;
        thumbImgWrapper.style.width = '100%';
        thumbImgWrapper.style.height = '100%';
        thumbImgWrapper.style.backgroundColor = 'white';
        thumbImgWrapper.style.borderRadius = '0.375rem';

        const thumbImg = document.createElement('img');
        thumbImg.classList.add('product-gallery--media-thumbnail-img');
        thumbImg.src = 'https://cdn.mazing.link/assets/svg/3D.svg';
        thumbImg.style.display = 'block';
        thumbImg.style.width = '100%';
        thumbImg.style.height = '100%';
        thumbImg.style.objectFit = 'contain';
        thumbImg.style.padding = '10%';
        thumbImg.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';

        if (existingThumb) {
            newThumbElement.style.width = getComputedStyle(existingThumb).width;
        }

        thumbImgWrapper.appendChild(thumbImg)
        newThumbElement.appendChild(thumbImgWrapper);

        // thumb gallery
        if (thumbGallery.children.length >= 1) {
            thumbGallery.insertBefore(newThumbElement, thumbGallery.children[1]);
        } else {
            thumbGallery.appendChild(newThumbElement);
        }

        // MAZING THUMB END

        // THUMB LISTENER START

        // Click listener for new inserted Mazing Thumb
        newThumbElement.addEventListener('click', (e) => {
            e.stopPropagation();
            // remove from all thumbGallery
            const allThumbs = thumbGallery.querySelectorAll('button');
            allThumbs.forEach(thumb => {
                thumb.setAttribute('data-gallery-selected', 'false');
                thumb.dataset.gallerySelected = 'false';
            });

            // remove from all imgGallery
            const allImages = imgGallery.querySelectorAll('figure');
            allImages.forEach(img => {
                img.setAttribute('aria-hidden', 'true');
                img.dataset.gallerySelected = 'false';
            });

            // activate clicked mazing thumb + iframe
            newThumbElement.setAttribute('data-gallery-selected', 'true');
            newThumbElement.dataset.gallerySelected = 'true';
            figureElement.setAttribute('aria-hidden', 'false');
            figureElement.dataset.gallerySelected = 'true';

            if (window.innerWidth <= 718) {
                figureElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        });


        // Click listener for all thumbs except for mazing thumb. Mazing thumb has its own listener logic
        Array.from(thumbGallery.children).forEach((thumb, index) => {
            if (thumb.id !== 'mazing-thumb') {
                thumb.addEventListener('click', (event) => {
                    event.stopPropagation();

                    // deactivate all images to remove prev active img
                    const allImages = imgGallery.querySelectorAll('figure');
                    allImages.forEach(img => {
                        img.setAttribute('aria-hidden', 'true');
                        img.dataset.gallerySelected = 'false';
                    });

                    // deactivate all thumbs to remove prev active thumb
                    const allThumbs = thumbGallery.querySelectorAll('button');
                    allThumbs.forEach(thumb => {
                        thumb.setAttribute('data-gallery-selected', 'false');
                        thumb.dataset.gallerySelected = 'false';
                    });

                    // deactivate mazing thumb + iframe
                    newThumbElement.dataset.gallerySelected = 'false';
                    figureElement.dataset.gallerySelected = 'false';
                    figureElement.setAttribute('aria-hidden', 'true');
                    newThumbElement.setAttribute('data-gallery-selected', 'false');

                    // activate clicked thumb
                    thumb.dataset.gallerySelected = 'true';
                    thumb.setAttribute('data-gallery-selected', 'true');

                    let correspondingFigure = imgGallery.querySelector(`figure[data-gallery-index="${index}"]`);

                    if (index > 1) {
                        correspondingFigure = imgGallery.querySelector(`figure[data-gallery-index="${index - 1}"]`);
                    }

                    if (correspondingFigure) {
                        // activate the corresponding figure
                        correspondingFigure.dataset.gallerySelected = 'true';
                        correspondingFigure.setAttribute('aria-hidden', 'false');

                        if (window.innerWidth <= 718) {
                            correspondingFigure.scrollIntoView({ behavior: "smooth", block: "center" });
                        }
                    }
                });
            }
        });


        // THUMB LISTENER END


        // PRODUCT ZOOM SECTION ------------ Second gallery -----------------

        const initZoomViewer = () => {

            const zoomDiv = document.getElementById('mazing-zoom-div');

            if (zoomDiv) {
                zoomDiv.remove();
            }

            // MAZING IFRAME START

            const zoomImgGallery = document.querySelector('.pswp__scroll-wrap');


            const zoomIframeWrapper = document.createElement('div');
            zoomIframeWrapper.classList.add('product-gallery--image-background');
            zoomIframeWrapper.style.overflow = 'hidden';
            zoomIframeWrapper.style.top = '0';
            zoomIframeWrapper.style.left = '0';
            zoomIframeWrapper.style.paddingTop = 'min(100%, 100%)';
            zoomIframeWrapper.style.maxWidth = '100%';
            zoomIframeWrapper.style.marginLeft = 'auto';
            zoomIframeWrapper.style.marginRight = 'auto';
            zoomIframeWrapper.style.height = '100%';
            zoomIframeWrapper.style.width = '100%';
            zoomIframeWrapper.style.display = 'none';
            zoomIframeWrapper.id = 'mazing-zoom-div';

            const zoomIframe = document.createElement('iframe');
            zoomIframe.src = iframeSrc;
            zoomIframe.style.border = '0';
            zoomIframe.style.height = '100%';
            zoomIframe.style.left = '0';
            zoomIframe.style.position = 'absolute';
            zoomIframe.style.maxHeight = '100%';
            zoomIframe.style.top = '0';
            zoomIframe.style.width = '100%';
            zoomIframe.setAttribute('allowusermedia', '');
            zoomIframe.setAttribute('allowfullscreen', '');
            zoomIframe.setAttribute('data-cy', 'cy-mazing-frame');
            zoomIframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking');


            zoomIframeWrapper.appendChild(zoomIframe);
            const firstZoomChild = zoomImgGallery.children[0];
            zoomImgGallery.insertBefore(zoomIframeWrapper, firstZoomChild.nextSibling);
            zoomImgGallery.style.scrollBehavior = 'smooth';
            zoomImgGallery.style.display = 'block';


            const zoomThumbGallery = document.querySelector('.product-zoom--thumb-scroller');

            // MAZING ZOOM THUMB START
            const newZoomThumbElement = document.createElement('div');
            newZoomThumbElement.classList.add('product-gallery--media-thumbnail');
            newZoomThumbElement.type = 'button';
            newZoomThumbElement.id = 'mazing-zoom-thumb';
            newZoomThumbElement.tabIndex = 0;
            newZoomThumbElement.setAttribute('data-gallery-selected', 'false');
            newZoomThumbElement.setAttribute('data-media-type', 'image');

            const zoomThumbImgWrapper = document.createElement('span');
            zoomThumbImgWrapper.classList.add('product-gallery--media-thumbnail-img-wrapper');
            zoomThumbImgWrapper.tabIndex = -1;
            zoomThumbImgWrapper.style.width = '100%';
            zoomThumbImgWrapper.style.height = '100%';
            zoomThumbImgWrapper.style.backgroundColor = 'white';
            zoomThumbImgWrapper.style.borderRadius = '0.375rem';

            const zoomThumbImg = document.createElement('img');
            zoomThumbImg.classList.add('product-gallery--media-thumbnail-img');
            zoomThumbImg.src = 'https://cdn.mazing.link/assets/svg/3D.svg';
            zoomThumbImg.style.display = 'block';
            zoomThumbImg.style.width = '100%';
            zoomThumbImg.style.height = '100%';
            zoomThumbImg.style.objectFit = 'contain';
            zoomThumbImg.style.padding = '10%';
            zoomThumbImg.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';

            if (existingThumb) {
              newZoomThumbElement.style.width = getComputedStyle(existingThumb).width;
            }

            zoomThumbImgWrapper.appendChild(zoomThumbImg)
            newZoomThumbElement.appendChild(zoomThumbImgWrapper);

            // zoom thumb gallery
            if (zoomThumbGallery.children.length >= 1) {
                zoomThumbGallery.insertBefore(newZoomThumbElement, zoomThumbGallery.firstElementChild.nextSibling);
            } else {
                zoomThumbGallery.appendChild(newZoomThumbElement);
            }


            // Click listener for new inserted Mazing Thumb
            newZoomThumbElement.addEventListener('click', (e) => {
                e.stopPropagation();
                // remove from all thumbGallery
                const allThumbs = zoomThumbGallery.querySelectorAll('button');
                allThumbs.forEach(thumb => {
                    thumb.setAttribute('data-gallery-selected', 'false');
                    thumb.dataset.gallerySelected = 'false';
                });

                // remove from all imgGallery
                const allImages = zoomImgGallery.querySelector('.pswp__container');
                allImages.style.display = 'none'

                // activate clicked mazing thumb + iframe
                newZoomThumbElement.setAttribute('data-gallery-selected', 'true');
                newZoomThumbElement.dataset.gallerySelected = 'true';
                zoomIframeWrapper.setAttribute('aria-hidden', 'false');
                zoomIframeWrapper.dataset.gallerySelected = 'true';
                zoomIframeWrapper.style.display = 'block';
            });


            // Click listener for all thumbs except for mazing thumb. Mazing thumb has its own listener logic
            Array.from(zoomThumbGallery.children).forEach((thumb, index) => {
                if (thumb.id !== 'mazing-zoom-thumb') {
                    thumb.addEventListener('click', (event) => {
                        event.stopPropagation();
                        event.preventDefault();

                        // deactivate all thumbs to remove prev active thumb
                        const allThumbs = zoomThumbGallery.querySelectorAll('button');
                        allThumbs.forEach((thumb) => {
                            thumb.setAttribute('data-gallery-selected', 'false');
                            thumb.dataset.gallerySelected = 'false';
                        });

                        // deactivate mazing thumb + iframe
                        newZoomThumbElement.dataset.gallerySelected = 'false';
                        newZoomThumbElement.setAttribute('data-gallery-selected', 'false');

                        // activate clicked thumb
                        thumb.setAttribute('data-gallery-selected', 'true');
                        thumb.dataset.gallerySelected = 'true';

                        const zoomImgContainer = zoomImgGallery.querySelector('.pswp__container');

                        if (zoomImgContainer) {
                            // activate the corresponding figure
                            zoomImgContainer.dataset.gallerySelected = 'true';
                            zoomImgContainer.setAttribute('aria-hidden', 'false');
                            zoomImgContainer.style.display = 'block';
                            zoomIframeWrapper.style.display = 'none';
                        }
                    });
                }
            });

        }


        imgGallery.addEventListener('click', (event) => {
            if (figureElement && figureElement.getAttribute('data-gallery-selected') === 'false') {
                initZoomViewer();
            }
        });

        document.querySelector('.product-gallery--expand').addEventListener('click', () => {
            initZoomViewer();
        })

      const optionsContainer = document.querySelector('.options-selection__option-values')
      
      if (optionsContainer) {
          Array.from(optionsContainer.children).forEach(option => {
              option.addEventListener('click', () => {
                setTimeout(() => {
                  const newProductSkuElement = document.querySelector('.product-sku span');
                  const mazingDiv = document.getElementById('mazing-div');
                  const currentIframe = mazingDiv ? mazingDiv.querySelector('iframe') : null;
                  console.log('newSKU', newProductSkuElement.textContent.trim().toLowerCase())
  
                  currentIframe.src = `https://mazing.link/modusfurniture/${newProductSkuElement.textContent.trim().toLowerCase()}`;
                }, 450)
              });
          });
      }


        console.log('initialized successfully.')
    } catch (error) {
        console.error('Initialization failed:', error);
    }
};

initializeScript();